export class InvestmentsSimulationEventType {

	static STEPS = {
		INVEST: 'INVEST',
		INVESTMENTS_OPTIONS: 'INVESTMENTS_OPTIONS',
		INVESTMENTS_CONFIRMATION: 'INVESTMENTS_CONFIRMATION',
		INVESTMENTS_SUMMARY: 'INVESTMENTS_SUMMARY'
	};

	static SEND = {
		INVEST_SEND: 'INVESTMENTS_SEND',
		INVESTMENTS_OPTIONS_SEND: 'INVESTMENTS_OPTIONS_SEND',
		INVESTMENTS_CONFIRMATION_SEND: 'INVESTMENTS_CONFIRMATION_SEND',
		INVESTMENTS_SUMMARY_SEND: 'INVESTMENTS_SUMMARY_SEND'
	};

	static ACTIONS = {
		BUTTONS: 'INVEST_BUTTONS'
	};

	static ERROR = 'INVEST_ERROR';

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/investments/investments-simulation/investments-simulation.event.type.ts